import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import Toggle from './../Toggle'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView07ImageOptions } from './views/ExteriorView07'

class Xr41Cockpit extends Component {
  constructor (props) {
    super(props)
    this.handleCockpitLockersChange = this.handleCockpitLockersChange.bind(this)
    this.handleRemovableFootChocksChange =
      this.handleRemovableFootChocksChange.bind(this)
    this.handleRemovableCockpitTableChange =
      this.handleRemovableCockpitTableChange.bind(this)
    this.handleRemovableCompassChange =
      this.handleRemovableCompassChange.bind(this)
  }

  handleCockpitLockersChange (event) {
    let configuration = this.props.configuration
    configuration.CockpitLockers = event.target.checked
      ? this.props.cockpitLockersOptions[1]
      : this.props.cockpitLockersOptions[0]

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleRemovableFootChocksChange (event) {
    let configuration = this.props.configuration
    configuration.RemovableFootChocks = event.target.checked
      ? this.props.removableFootChocksOptions[1]
      : this.props.removableFootChocksOptions[0]

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleRemovableCockpitTableChange (event) {
    let configuration = this.props.configuration
    configuration.RemovableCockpitTable = event.target.checked
      ? this.props.removableCockpitTableOptions[1]
      : this.props.removableCockpitTableOptions[0]

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleRemovableCompassChange (event) {
    let configuration = this.props.configuration
    configuration.RemovableCompass = event.target.checked
      ? this.props.removableCompassOptions[1]
      : this.props.removableCompassOptions[0]

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

    render() {
        let imageOptions = exteriorView07ImageOptions

    let image = (
      <ConfiguratorImage
        boat='Xr41'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Cockpit' />
                </h1>

                <p className="RadioGroup-title">
                    <Trans defaults='Options:' />
                </p>


          <Toggle
            checked={this.props.configuration.CockpitLockers.value === 2}
            onChange={this.handleCockpitLockersChange}
          >
            <Trans defaults='Cockpit Lockers' />
          </Toggle>

          <Toggle
            checked={this.props.configuration.RemovableFootChocks.value === 2}
            onChange={this.handleRemovableFootChocksChange}
          >
            <Trans defaults='Removable Foot Chocks' />
          </Toggle>

          <Toggle
            checked={this.props.configuration.RemovableCockpitTable.value === 2}
            onChange={this.handleRemovableCockpitTableChange}
          >
            <Trans defaults='Removable Cockpit Table' />
          </Toggle>

          <Toggle
            checked={this.props.configuration.RemovableCompass.value === 2}
            onChange={this.handleRemovableCompassChange}
          >
            <Trans defaults='Compass at pedestals' />
          </Toggle>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Cockpit)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Cockpit.js